module.exports = __webpack_public_path__ + "img/Investment.ac67e215.svg";